(function ($) {

  /**
   * Zentraler State für den Back-to-Top Button
   * Speichert Sichtbarkeit, Hover-Status und Timeout-Handling
   */
  let state = {
    isVisible: false,          // Ist der Button aktuell sichtbar?
    isHovering: false,         // Hovert der User gerade über dem Button?
    inactivityTimeout: null,   // Timeout-Referenz für automatisches Ausblenden
    inactiveDelay: 3000,       // Zeit (ms) bis Button nach Inaktivität ausgeblendet wird
    $button: null,             // jQuery Referenz auf das Button-Element
    supportsHover: window.matchMedia('(hover: hover) and (pointer: fine)').matches
  };

  /**
   * Speichert die letzte bekannte Scrollposition
   * (wichtig für MutationObserver Events ohne Scroll-Daten)
   */
  let lastScrollPosition = 0;

  // Initialisierung: Button erzeugen und Listener registrieren
  createButton();
  addScrollHandler();
  addClickHandler();
  addHoverHandler();
  addPlayerbarObserver();
  addContentWrapperObserver();

  /**
   * Erstellt den Back-to-Top Button, falls er noch nicht existiert
   */
  function createButton() {
    if ($('#back-to-top-button').length) {
      // Button existiert bereits → Referenz setzen und abbrechen
      state.$button = $('#back-to-top-button');
      return;
    }

    // Button HTML erzeugen und ans Body-Ende hängen
    const btn = `
      <div id="back-to-top-button" class="back-to-top">
        <button class="btn btn-tertiary" type="button" aria-hidden="true" tabindex="-1">
          ${SWRNEU.Util.svgIcon("back-to-top", "Nach oben")} Nach oben
        </button>
      </div>`;

    $('body').append(btn);
    state.$button = $('#back-to-top-button');
  }

  /**
   * Listener für Scroll-Events (Custom Event: swr:scroll:scrolled)
   * → bei Scroll wird Button-Status neu berechnet
   */
  function addScrollHandler() {
    $(document).on('swr:scroll:scrolled', (event, data) =>
      evaluateButtonState(data)
    );
  }

  /**
   * Klick-Handler: Scrollt smooth nach oben und blendet Button aus
   */
  function addClickHandler() {
    state.$button.on('click', function (e) {
      e.preventDefault();

      state.isHovering = false;
      clearTimeout(state.inactivityTimeout);

      // Smooth Scroll zurück nach oben
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      // Button sofort ausblenden
      hideButtonFade(true);
      this.blur();

      // Fokus zurück auf Hauptcontent (Accessibility)
      $('#content').focus();
    });
  }

  /**
   * Hover-Handling:
   * - Beim Hover bleibt Button sichtbar
   * - Timeout zum Ausblenden wird gestoppt
   */
  function addHoverHandler() {
    if (!state.supportsHover) return;

    state.$button.on('mouseenter', function () {
      state.isHovering = true;
      clearTimeout(state.inactivityTimeout);
    });

    state.$button.on('mouseleave', function () {
      state.isHovering = false;
      resetInactivityTimer();
    });
  }

  /**
   * Listener für Klassenänderungen der Playerbar
   * → Playerbar fährt hoch/runter → Button reagiert entsprechend
   */
  function addPlayerbarObserver() {
    const $playerbar = $('#playerbar');

    // MutationObserver reagiert auf class-Änderungen
    const observer = new MutationObserver(evaluateButtonState);

    observer.observe($playerbar[0], {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /**
   * Observer für Content Wrapper:
   * Wenn sich Klassen ändern → Button ausblenden
   */
  function addContentWrapperObserver() {
    const el = document.getElementById('content-wrapper');
    if (!el) return;

    const observer = new MutationObserver(() => {
      hideButtonFade(true);
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /**
   * Button sichtbar machen (Slide Up Animation)
   */
  function showButton() {
    if (state.isVisible) return;

    state.isVisible = true;
    state.$button
      .removeClass('slide-down')
      .addClass('slide-up show');
  }

  /**
   * Button per Fade ausblenden
   * force=true ignoriert Hover-Status
   */
  function hideButtonFade(force = false) {
    if (!state.isVisible) return;
    if (!force && state.isHovering) return;

    state.isVisible = false;
    state.$button.removeClass('show');
  }

  /**
   * Button per Slide-Down ausblenden
   */
  function hideButtonSlide() {
    if (state.isHovering) return;

    state.isVisible = false;
    state.$button
      .removeClass('slide-up show')
      .addClass('slide-down');
  }

  /**
   * Startet einen Timer, um den Button nach Inaktivität auszublenden
   */
  function resetInactivityTimer() {
    clearTimeout(state.inactivityTimeout);

    // Button nur ausblenden, wenn er sichtbar ist und User weit genug gescrollt hat
    if (!state.isVisible || state.isHovering || lastScrollPosition < window.innerHeight * 0.5) return;

    state.inactivityTimeout = setTimeout(function () {
      hideButtonFade();
    }, state.inactiveDelay);
  }

  /**
   * Hauptlogik:
   * Entscheidet, ob Button angezeigt oder versteckt wird
   */
  function evaluateButtonState(data = {}) {
    let scrollTop;
    const $playerbar = $('#playerbar');

    // Scrollposition aus Event übernehmen oder letzte bekannte nutzen
    if (data.hasOwnProperty('position')) {
      scrollTop = data.position;
      lastScrollPosition = scrollTop;
    } else {
      scrollTop = lastScrollPosition;
    }

    // Ganz oben: Button sofort ausblenden
    if (scrollTop < window.innerHeight * 0.5) {
      hideButtonFade(true);
      return;
    }

    // Wenn User hovert → Button bleibt sichtbar
    if (state.isHovering) {
      showButton();
      return;
    }

    // Playerbar oben → Button anzeigen
    if ($playerbar.hasClass('playerbar-up')) {
      if (!state.isVisible) {
        showButton();
        resetInactivityTimer();
      }

      // Playerbar unten → Button wegsliden
    } else if ($playerbar.hasClass('playerbar-down')) {
      hideButtonSlide();
    }
  }

})(window.jQuery);
